import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-rejected-dialog" }
const _hoisted_2 = { class: "order-rejected-dialog__heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "order-rejected-dialog__description" }, [
  /*#__PURE__*/_createTextVNode(" Please contact "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:hello@glazeprosthetics.com",
    target: "_blank"
  }, "hello@glazeprosthetics.com"),
  /*#__PURE__*/_createTextVNode(" to understand what was the problem with the order. ")
], -1)
const _hoisted_4 = { class: "order-rejected-dialog__buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ok, close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Sorry, your order #" + _toDisplayString(_ctx.notification.data.order_number) + " was rejected by Glaze. ", 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_base_button, {
        loading: _ctx.isLoading,
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}